import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FiPhone, FiCopy } from 'react-icons/fi';

export default function BankDepositInfo({ bankDetails }) {
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        // Simple native alert or a subtle toast could go here
    };

    return (
        <div className="space-y-6">
            {/* Simple Blue Header */}
            <div className="bg-blue-600 rounded-2xl p-8 text-white">
                <h1 className="text-3xl font-bold mb-1">Bank Deposit Information</h1>
                <p className="text-blue-100 opacity-90">Direct bank or ATM deposits for class payments</p>
            </div>

            {/* Instruction Boxes */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-green-600 rounded-2xl p-6 text-white flex items-center gap-5">
                    <div className="bg-white/20 p-3 rounded-xl">
                        <FaWhatsapp size={28} />
                    </div>
                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-wider opacity-80 mb-0.5">WhatsApp Support</p>
                        <p className="text-xl font-bold mb-1">0776 361 017</p>
                        <p className="text-[10px] leading-tight opacity-90">අංකය සහ පන්තිය සදහන් කර whatsapp කරන්න.</p>
                    </div>
                </div>

                <div className="bg-white border border-gray-100 rounded-2xl p-6 flex items-center gap-5 shadow-sm">
                    <div className="bg-blue-50 text-blue-600 p-3 rounded-xl">
                        <FiPhone size={28} />
                    </div>
                    <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Technical Support</p>
                        <p className="text-xl font-bold text-gray-900">0772 700 701</p>
                        <p className="text-[10px] text-gray-500">Available Daily: 8 AM - 8 PM</p>
                    </div>
                </div>
            </div>

            {/* Simple Bank Cards */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {bankDetails.map((bank, index) => (
                    <div key={index} className="bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-md transition-shadow group">
                        <div className="flex items-start gap-4 mb-4">
                            <div className="w-16 h-12 flex-shrink-0 flex items-center justify-center p-2 bg-gray-50 rounded-lg">
                                <img src={bank.logo} alt={bank.bank} className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all" />
                            </div>
                            <div className="min-w-0">
                                <h3 className="text-blue-600 font-bold text-sm truncate uppercase tracking-tight">{bank.bank}</h3>
                                <p className="text-[11px] text-gray-400 font-medium">Branch: {bank.branch}</p>
                            </div>
                        </div>

                        <div className="space-y-3 pt-3 border-t border-gray-50">
                            <div>
                                <label className="text-[9px] font-bold text-gray-400 uppercase tracking-widest block mb-1">Account Name</label>
                                <p className="text-xs font-bold text-gray-800 uppercase">{bank.accountName}</p>
                            </div>
                            <div>
                                <label className="text-[9px] font-bold text-gray-400 uppercase tracking-widest block mb-1">Account Number</label>
                                <div className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg">
                                    <span className="text-sm font-mono font-bold text-gray-900">{bank.accountNo}</span>
                                    <button
                                        onClick={() => copyToClipboard(bank.accountNo)}
                                        className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                                        title="Copy"
                                    >
                                        <FiCopy size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
